<template src= "./index.html"></template>

<script>
import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'
export default {
    name: 'artistList',
  
    data () {
        return {
            dateOption : [
                {value: 'opened_at',label: '정산공개일',},
                {value: 'service_start_date',label: '서비스시작일',},
            ],
            dateType :'opened_at' ,

            startDate :null,
            endDate : null,
            
            aggregatorList : [
                {name: '전체',id :null},
            ],
            aggregator : null,
            
            operationList : [   
                {name: '전체',id :null}
            ],
            operation : null,

            storeList : [
                {name: '전체',id :null}
            ],
            store : null,
            
            storeTypeOption:[
                {value: null, label: '전체'},
                {value: 'korea', label: '국내'},
                {value: 'other', label:'해외'},
            ],
            storeType : null,
            storeOption:[],
            store : null,

            typeOption : [
                {value: null, label: '전체'},
                {value: 'DL', label: '다운로드'},
                {value: 'ST', label:'스트리밍'},
                {value: 'OTHER', label:'기타'},
            ],
            type : null,
            countryOption : [
                {name:"전체", name_en: "All", code: null},
                ...optionData.country,
                
            ],
            country: null,
            keywordOption :[
                {value: 'email', label:'Email ID'},
                {value: 'track_title', label:'트랙명'},
                {value: 'album_title', label:'앨범명'},
                {value: 'artist_name',label: '아티스트명',},
                {value: 'track_ref',label: '자사트랙코드'},
                {value: 'isrc',label: 'ISRC',},
                {value: 'upc',label: 'UPC',},
                {value: '_name', label:'권리자명'},
                {value: 'company', label:'회사명'},
                {value: 'licensor_id', label:'LID'},
                
            ],
            keywordType :'_name',
            keyword : '',
        }
    },
    created(){
    },
    mounted(){
        this.$nextTick(() =>{
            this.callList();
            this.operationCall();
            this.storeCall();
        })
    },
    computed: {
        
    },
    watch: {
        aggregator(id){
            this.operationCall(id)
        },
        operation(id){
            this.storeCall(id)
        }
    },
    methods: {
        callList(){
            this.loadingShow()
            this.$store.dispatch('GET_AGGREGATOR')
            .then(result =>{
                this.loadingHide()
                this.aggregatorList  = [
                    {name: '전체',id :null},
                    ...result
                ] // 권리자 목록
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        //운영사 리스트
        operationCall(id){
            let payload = {
                params : {
                    page: 0 ,
                    limit: 200,
                }
            }
            if(id){
                payload['id'] =id 
                this.operation = null
                this.store = null
                this.$store.dispatch('GET_OPERATE_LIST', payload)
                    .then(result =>{
                        this.loadingHide()    
                        console.log(result)
                        this.errorName = name
                        this.operationList  = [
                            {name:'전체' , id : null},
                            ...result.items
                        ] 
                        this.cellOptionList  = result.items
                        
                    }).catch(error=>{
                        const status = error.response.status
                        this.loadingHide()
                        switch(status){
                            case 401:
                            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                            break;
                            default:
                                this.alert({msg : error.response.data.message})
                            break;
                        }
                    })
            }else{
                this.operationList  = [
                    {name:'전체' , id : null},
                ]
                this.operation = null
                this.$store.dispatch('GET_OPERATE_LIST_V2', payload)
                    .then(result =>{
                        this.loadingHide()    
                        console.log(result)
                        this.errorName = name
                        this.operationList  = [
                            {name:'전체' , id : null},
                            ...result.items
                        ] 
                        this.cellOptionList  = result.items
                        
                    }).catch(error=>{
                        const status = error.response.status
                        this.loadingHide()
                        switch(status){
                            case 401:
                            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                            break;
                            default:
                                this.alert({msg : error.response.data.message})
                            break;
                        }
                })
            }
            
            
        },
        storeCall(id){
            const option = {
                sort: 'created_at',
                sortorder: 'desc',
                page: 0 ,
                limit: 500,
                //is_various_artists: false, // 필수 filter
            }
            

            if(id && !this.valCheck(id) ) {
                option['operator_id'] = this.operation
            }   
            this.store = null
            this.loadingShow()
            this.$store.dispatch('GET_MUSICSTORE', option)
            .then(result =>{
                this.loadingHide()
                this.storeList  = [
                    {name:'전체', id : null},
                    ...result.items
                ] // 권리자 목록
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        download(){
            let option = {

            }
            if( !this.valCheck(this.dateType) && !this.valCheck(this.startDate) && !this.valCheck(this.endDate)){
                option['standard_date_type'] = this.dateType
                option['standard_date_start'] = this.startDate
                option['standard_date_end'] = this.endDate
            }else{
                this.alert({msg :'기간을 입력해주세요.'})
                return false
            }
            if(!this.valCheck(this.aggregator)){
                option['aggregator_id'] = this.aggregator
            }
            if(!this.valCheck(this.operation)){
                option['operator_id'] = this.operation
            }
            if(!this.valCheck(this.store)){
                option['musicstore_id'] = this.store
            }
            if(!this.valCheck(this.storeType)){
                option['store_type'] = this.storeType
            }
            if(!this.valCheck(this.type)){
                option['service_type'] = this.type
            }
            if(!this.valCheck(this.country)){
                option['country'] = this.country
            }
            if(!this.valCheck(this.keywordType) && !this.valCheck(this.keyword) ){
                option[this.keywordType] = this.keyword
            }
            this.loadingShow()
            this.$store.dispatch('GET_SALESLINE_ACCOUNTS_EXCEL',option)
            .then(result =>{
                this.loadingHide()
                this.alert({msg : `요청이 완료되었습니다. \ 파일 준비 완료시 본인 Slack으로 Excel 파일 다운로드 링크가 발송됩니다.`})
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
